import { useMemo } from "react";
import { useMe } from "../../lib/me";
import { ErrorText } from "../../ui";
import { ChannelList } from "./ChannelList";
import { useChannels, useMembers, useReadMarkers } from "./data";
import { unreadIds } from "./model";

/** A workspace's channels and DMs, my read markers in them, and which are unread (the open one never is). */
export function useChatList(workspaceId: string, channelId: string | null) {
  const me = useMe();
  const channels = useChannels(workspaceId, me.uid);
  const members = useMembers(workspaceId);
  const list = useMemo(() => (channels.status === "ready" ? channels.data : []), [channels]);
  const reads = useReadMarkers(
    workspaceId,
    list.map((c) => c.id),
    me.uid,
  );
  return { channels, list, members, reads, unread: unreadIds(list, reads, channelId) };
}

/** The conversation list: in the chat page on a phone or beside a rail, else in the sidebar (WP-056). */
export function ChatConversations({ workspaceId, channelId }: { workspaceId: string; channelId: string | null }) {
  const me = useMe();
  const { channels, list, members, unread } = useChatList(workspaceId, channelId);
  return (
    <>
      {channels.status === "loading" ? <p className="px-3 text-sm text-muted">Loading conversations…</p> : null}
      {channels.status === "error" ? <ErrorText>Conversations could not be loaded: {channels.error.message}</ErrorText> : null}
      {channels.status === "ready" ? (
        <ChannelList workspaceId={workspaceId} myUid={me.uid} channels={list} unread={unread} members={members.byUid} memberList={members.list} />
      ) : null}
    </>
  );
}
